import { getRecipientName } from '../helpers';
import { MessageRenderer } from '../interfaces/messageRenderer';

export class MAMessageRenderer implements MessageRenderer {
    render(template: string): string {
        let recipient = getRecipientName();

        if (recipient === '') {
            // TODO: Either move the string to resource file
            // or update the Prov app to provide the parameter.
            recipient = 'your provider';
        }

        return template.replace(/\{recipient_message\}/g, recipient);
    }
}
